import Image from "next/image";
import styles from "./steps.module.scss";

const StepPreview = ({ condition, imageUrl, alt, imageProps }) => {
  if (!condition) return null;
  return <Image className={styles.stepPreview} src={imageUrl} alt={alt} {...imageProps} />;
};

const LogoPreview = ({ template, logo, imageProps }) => {
  if (!logo) return null;

  return (
    <>
      {template?.has_logo1 && logo[1] && (
        <Image
          className={styles.stepPreview}
          src={logo[1].image_url}
          alt="logo1"
          {...imageProps}
        />
      )}
      {template?.has_logo2 && logo[2] && (
        <Image
          className={styles.stepPreview}
          src={logo[2].image_url}
          alt="logo2"
          {...imageProps}
        />
      )}
    </>
  );
};

const Steps = ({ steps, setSteps, sportCardsState }) => {
  const { template, person, pose, background, logo } = sportCardsState;

  const isStepDisabled = (stepName) => {
    const conditions = {
      Selfie: person?.status !== "CREATED",
      Download: person === null || person?.status !== "PREPARED",
      Template: false,
      default: person === null || (stepName !== "Template" && template === null)
    };

    return conditions[stepName] ?? conditions.default;
  };

  const handleClick = (target, index) => {
    target.scrollIntoView({ behavior: 'smooth', inline: 'center' });
    setSteps(steps.map((item, i) => ({
      ...item,
      active: i === index
    })));
  };

  const imageProps = { width: 64, height: 64, quality: 99, unoptimized: true };

  const renderStepPreview = (step) => {
    const previewMap = {
      Selfie: {
        condition: person?.image_url,
        imageUrl: person?.image_url,
        alt: "person"
      },
      Pose: {
        condition: pose,
        imageUrl: pose?.name,
        alt: "pose"
      },
      Background: {
        condition: background,
        imageUrl: background?.image_url,
        alt: "background"
      },
      Logo: {
        condition: logo,
        component: <LogoPreview
          template={template}
          logo={logo}
          imageProps={imageProps}
        />
      }
    };

    const preview = previewMap[step.name];
    if (!preview) return null;

    return preview.component || (
      <StepPreview
        condition={preview.condition}
        imageUrl={preview.imageUrl}
        alt={preview.alt}
        imageProps={imageProps}
      />
    );
  };

  return (
    <div className={styles.steps}>
      {steps.map((step, index) => (
        <button
          key={step.name}
          disabled={isStepDisabled(step.name)}
          className={`${styles.step} ${step.active ? styles.active : ""}`}
          onClick={({ target }) => handleClick(target, index)}
        >
          <div className={styles.step_number}>{index + 1}</div>
          <div className={styles.step_text}>{step.name}</div>
          {renderStepPreview(step)}
        </button>
      ))}
    </div>
  );
};

export default Steps;